// extracted by mini-css-extract-plugin
export var compactFilters = "_i1-4";
export var detailImage = "_i1-1";
export var dropdownContainer = "_i1-2";
export var imageContainer = "_i1-0";
export var selectedCard = "_i1-3";